import { render } from "./page-loader.vue?vue&type=template&id=e5a3cf30&scoped=true"
import script from "./page-loader.vue?vue&type=script&lang=js"
export * from "./page-loader.vue?vue&type=script&lang=js"

import "./page-loader.vue?vue&type=style&index=0&id=e5a3cf30&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e5a3cf30"]])

export default __exports__